import { render } from "./TaskBoard.vue?vue&type=template&id=02cb4e8c"
import script from "./TaskBoard.vue?vue&type=script&lang=js"
export * from "./TaskBoard.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__